import { render, staticRenderFns } from "./TouGePc.vue?vue&type=template&id=49fd4076&scoped=true"
import script from "./TouGePc.vue?vue&type=script&lang=js"
export * from "./TouGePc.vue?vue&type=script&lang=js"
import style0 from "./TouGePc.vue?vue&type=style&index=0&id=49fd4076&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd4076",
  null
  
)

export default component.exports